import { render } from "./OrderQuoteRespDetail.vue?vue&type=template&id=397e642d&scoped=true"
import script from "./OrderQuoteRespDetail.vue?vue&type=script&lang=js"
export * from "./OrderQuoteRespDetail.vue?vue&type=script&lang=js"

import "./OrderQuoteRespDetail.vue?vue&type=style&index=0&id=397e642d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-397e642d"]])

export default __exports__